export default  {
    blank : function (obj) { 
        var cache;
    
        if((cache = typeof obj) !== 'boolean' && (cache !== 'number' || isNaN(obj)) && !obj)
            return true;
        if(cache == 'string' && obj.replace(/\s/g, '').length === 0)
            return true;
        if(cache == 'object') {
            if((cache = toString.call(obj)) == '[object Array]' && obj.length === 0)
                return true;
            if(cache == '[object Object]') {
                for(cache in obj) {
                    return false;
                }
                return true;
            }
        }
    
        return false;
    },
    squish: function (str) {
        //let newString = String(str).replace(/[\\^$*+?()|[\]{}]/g, ' ');
        return str.trim().replace(/\s\s+/g, ' ');
    }
} 